import React, { useEffect, useState } from 'react'
import { ICartItem, ICatagoryItemListResult, ISuggestedItems } from '../../types/categoryListType'
import useStore, { useCartListStore, userStore } from '../../store/store';
import { useSnackBar } from '../context/snackbar-context';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import Carousel from 'react-multi-carousel';
import { responsiveForPopup } from '../../common/carouselCommonProperty';
import { useInformationPopup } from '../context/information-context';
import { CartService } from '../../services/CartService';
import { GetErrorMessageFromResponse } from '../../common/commonFunction';
import { EmployeeOnboardingEquipmentService } from '../../services/EmployeeOnboardingEquipmentModule/EmployeeOnboardingEquipmentService';
import { HardwarePackagesRoleService } from '../../services/HardwarePackagesforRolesModule/HardwarePackagesRoleService';
interface props {
    suggestiveItemList: ISuggestedItems[],
    isOpenSuggestedItemDialog: boolean,
    handleCloseNewEmployeeItemPopup: (showNewEmployeeItemPopup: boolean) => void,
    currentItemList: any,
}



const ShowNewEmployeeItems: React.FC<props> = ({ currentItemList, suggestiveItemList, isOpenSuggestedItemDialog, handleCloseNewEmployeeItemPopup }) => {

    const [showFormPopup, setShowFormPopup] = useState<boolean>(false);
    const [itemData, setItemData] = useState<any>();
    const [openDialog, setOpenDialog] = React.useState(false);
    const [equipmentItemList, setEquipmentItemList] = useState<any>([]);
    const cStore: any = useCartListStore();
    const [selectedItems, setSelectedItems] = useState<any>([]);
    const snackbar = useSnackBar();
    const { allItemList } = useStore();
    const uStore: any = userStore();
    const handleCloseDialog = () => {
        setOpenDialog(false);
        handleCloseNewEmployeeItemPopup(false);
    };
    const infoPopup = useInformationPopup();
    const handleCloseItemFormPopup = (showFormPopup: boolean) => {
        setShowFormPopup(showFormPopup);
    }

    const handleDialog = () => {
        setOpenDialog(isOpenSuggestedItemDialog);
    };

    const AddMultipleItemsToCartItem = async () => {
        var filteredArray = selectedItems.filter(function (id: any) {
            return id !== null;
        });
        CartService.AddMultipleItemsintoCart(uStore.user.userEmail, filteredArray).then((res: any) => {
            if (res) {
                if (res.data.code === 200) {
                    infoPopup.showPopup("Your items have been added to your cart!");
                    cStore.fetchCartList(uStore.user.userEmail);
                    handleCloseDialog();
                }
                else {
                    snackbar.showSnackBar("Item has not been added to your cart.", "info");
                }
            }
        })
            .catch((error: any) => {
                snackbar.showSnackBar(GetErrorMessageFromResponse(error), "error");
            })

        // if (await pStore.setCartList(uStore.user.userEmail, itemDetails)) {
        //     // snackBar.showSnackBar("Item has been added to your cart!", "success");
        //     infoPopup.showPopup("Your items have been added to your cart!");

        // }
        // else
        //     snackBar.showSnackBar("Item has already in your cart.", "info");
        handleCloseItemFormPopup(false);
    }

    const handleCheckboxChange = (itemID: any, index: any) => {
        if (itemID) {
            let exData = [...selectedItems];
            const isSelected = exData[index]?.toString() === itemID?.toString();
            if (isSelected) {
            // If already selected, remove from the list
                exData = exData.map((x: any, i: number) => (i === index ? null : x));
            } else {
                // If not selected, add to the list
                exData[index] = itemID?.toString();
            }
            setSelectedItems(exData)
        }
    };

    const getEquipmetItemlist = () => {
        let employeeRole = "";
        if (currentItemList && currentItemList.formData) {
            let formDataDetails = JSON.parse(currentItemList.formData);
            employeeRole = formDataDetails['Employee Role'];
            HardwarePackagesRoleService.GetSpecificEmployeeRole(employeeRole)
            .then((res: any) => {
                if (res && res.data.code === 200) {
                    let itemsIds = res.data.data.itemIds.split(",");
                    let SelectedItemsList: any = [];
                    itemsIds.map((id: any) => {
                        const temp_obj = allItemList.find((x: ICatagoryItemListResult) => x.id === Number(id));
                        if (temp_obj) {
                            SelectedItemsList.push(temp_obj);
                        }
                    });
                    // Only select item with id '9' by default
                    const defaultSelected = itemsIds.map((id: any) => id === '9' ? id : null);
                    setSelectedItems(defaultSelected);
                    setEquipmentItemList(SelectedItemsList);
                }
                else {
                    snackbar.showSnackBar(res.data.data, "error");
                }
            })
            .catch(err => {
                snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error")
            })
        }
    }

    useEffect(() => {
        getEquipmetItemlist();
        handleDialog();
    }, [isOpenSuggestedItemDialog])

    return (
        <Dialog className='AddUserDialog' open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
            <DialogTitle className='DialogTitleDiv' sx={{ fontWeight: "bold", bgcolor: '#f5f5f5', color: '#1976d2', fontSize: '1.35rem', borderBottom: '1px solid #eee' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    Standard Equipment Package
                </span>
            </DialogTitle>
            <div style={{ marginBottom: 12, marginTop: 12, textAlign: 'center' }}>
                <span style={{ fontSize: '1.15rem', color: '#1976d2', fontWeight: 500, letterSpacing: 0.2 }}>
                    Please select all items the employee should receive:
                </span>
            </div>
            <DialogContent sx={{ bgcolor: '#fafafa', minHeight: 180 }}>
                <div className='newEmployeeListDiv' style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                    {equipmentItemList && equipmentItemList.length > 0 ? (
                        equipmentItemList.map((list: any, i: number) => (
                            <div className="newEmployeeListItemDiv" key={i} style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                gap: 0,
                                padding: '12px 0',
                                borderRadius: 8,
                                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                                background: '#fff',
                                minHeight: 70
                            }}>
                                <div style={{ width: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <input
                                        type="checkbox"
                                        checked={selectedItems[i]?.toString() === list.id.toString()}
                                        onChange={() => handleCheckboxChange(list.id, i)}
                                        style={{ width: 22, height: 22, accentColor: '#1976d2' }}
                                    />
                                </div>
                                <div className='newEmployeeListItemImageDiv' style={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f4fa', borderRadius: 8, margin: '0 16px' }}>
                                    <img src={list.imageUrl} alt={list.equipmentName} style={{ maxWidth: '48px', maxHeight: '48px', borderRadius: 6, objectFit: 'contain' }} />
                                </div>
                                <div style={{ flex: 1, display: 'flex', alignItems: 'center', minHeight: 48 }}>
                                    <span style={{ fontSize: '1.08rem', color: '#333', fontWeight: 500 }}>{list.description}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <label style={{ color: '#888', fontSize: '1.05rem', textAlign: 'center' }}>Item not found</label>
                    )}
                </div>
            </DialogContent>
            <DialogActions sx={{ p: 2, bgcolor: '#f5f5f5', borderTop: '1px solid #eee', justifyContent: 'space-between' }}>
                <Button sx={{ fontSize: "1.08rem", px: 3, py: 1.2, bgcolor: '#fff', color: '#1976d2', border: '1px solid #1976d2', boxShadow: 'none', '&:hover': { bgcolor: '#e3f2fd' } }} variant="outlined" onClick={handleCloseDialog}>
                    Cancel
                </Button>
                {equipmentItemList && equipmentItemList.length > 0 && (
                    <Button sx={{ fontSize: "1.08rem", px: 3, py: 1.2, bgcolor: '#1976d2', color: '#fff', boxShadow: 'none', '&:hover': { bgcolor: '#1565c0' } }} variant="contained" onClick={() => {
                        if (selectedItems && selectedItems.length > 0) {
                            AddMultipleItemsToCartItem();
                        }
                    }}>
                        Continue
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}

export default ShowNewEmployeeItems